// import React, { useState } from 'react';
// import Logo from '../../assets/Logo.svg';
// import bgImage from "../../assets/back.png";
// import { Link } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom';

// const TeamManagement = () => {
//     const navigate = useNavigate();

//     return (
//         <div
//             className="min-h-screen flex items-center justify-center bg-cover bg-center relative"
//             style={{background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)'}}
//         >
//             <div className="flex flex-col items-center relative">
//                 {/* Logo outside the container */}
//                 <img src={Logo} alt="Logo" className="mb-4 w-[263px] z-10" />

//                 <div
//                     className="bg-white mb-4 rounded-2xl shadow-xl w-full sm:w-[490px] ps-8 pe-8 pb-8 pt-4 text-center"
//                 >
//                     <h2 className="text-2xl font-bold font-inter text-[#2D0076] font-[32px]">Team Management</h2>
//                     <p className="text-sm font-nunito text-[#202224] font-600 mb-6">Let’s Manage your team, just add team member details</p>

//                     <div className="text-left mb-4">
//                         <label className="block font-[18px] text-[#20224] mb-1">Member Role</label>
//                         <select
//                             className="w-full px-2 py-2 border bg-[#F1F4F9] text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
//                         >
//                             <option>Select Member Role</option>
//                             <option>Admin</option>
//                             <option>Dispatcher</option>
//                             <option>Driver</option>
//                         </select>
//                     </div>

//                     <div className="text-left mb-4">
//                         <label className="block font-[18px] text-[#20224] mb-1">Name</label>
//                         <input
//                             type="text"
//                             placeholder="Name"
//                             className="w-full px-4 py-2 border bg-[#F1F4F9] text-[#A6A6A6]  border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
//                             defaultValue="Suresh Patel"
//                         />
//                     </div>

//                     <div className="text-left mb-4">
//                         <label className="block font-[18px] text-[#20224] mb-1">Email</label>
//                         <input
//                             type="email"
//                             placeholder="Email"
//                             className="w-full px-4 py-2 bg-[#F1F4F9] text-[#A6A6A6]  border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
//                             defaultValue="suresh@dispax.com"
//                         />
//                     </div>

//                     <button
//                         className="w-full bg-[#6F1AFF] text-white font-semibold py-2 rounded-md transition"
//                         onClick={() => navigate('/add-member')}
//                     >
//                         Add Member
//                     </button>

//                     <p className="text-[#00217A] font-[20px] mt-3">
//                         <Link to="/add-member" className="text-[#00217A] font-[20px] font-bold hover:underline">Skip</Link>
//                     </p>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default TeamManagement;

import React, { useState } from 'react';
import Logo from '../../assets/Logo.svg';
import { Link } from 'react-router-dom';
import { addTeamMember } from '../../ApiController/ApiService';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
const TeamManagement = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    userType: "",
  });
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    // Map select option values to API-expected values
    const userTypeMap = {
      Admin: "USERADMIN",
      Dispatcher: "USERDISPATCHER",
      Driver: "DRIVER",
    };
    const payload = {
      ...formData,
      userType: userTypeMap[formData.userType] || formData.userType,
    };

    try {
      await addTeamMember(payload);
      await Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: 'Team member added successfully.',
        confirmButtonText: 'OK',
        confirmButtonColor: '#6F1AFF',
      });
      setFormData({ fullName: "", email: "", userType: "" }); // Reset form
      navigate('/add-member')
    } catch (err) {
      setError(err.message || 'Failed to add team member');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-cover bg-center relative"
      style={{ background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)' }}
    >
      <div className="flex flex-col items-center mx-4 relative">
        <img src={Logo} alt="Logo" className="mb-4 w-[263px] z-10" />

        <div className="bg-white mb-4 rounded-2xl shadow-xl w-full sm:w-[490px] p-8 text-center">
          <h2 className="text-2xl font-bold font-inter text-[#2D0076] text-[32px]">Team Management</h2>
          <p className="text-sm font-nunito text-[#202224] font-semibold mb-6">
            Let’s manage your team, just add team member details
          </p>

          {error && (
            <div className="text-red-500 text-sm text-center mb-4">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="text-left">
              <label className="block text-[18px] text-[#202224] mb-1">Member Role</label>
              <select
                name="userType"
                value={formData.userType}
                onChange={handleInputChange}
                className="w-full px-2 py-2 border bg-[#F1F4F9] text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                required
              >
                <option value="">Select Member Role</option>
                <option value="Admin">Admin</option>
                <option value="Dispatcher">Dispatcher</option>
                <option value='Driver'>Driver</option>
              </select>
            </div>

            <div className="text-left">
              <label className="block text-[18px] text-[#202224] mb-1">Name</label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleInputChange}
                placeholder="Name"
                className="w-full px-4 py-2 border bg-[#F1F4F9] text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                required
              />
            </div>

            <div className="text-left">
              <label className="block text-[18px] text-[#202224] mb-1">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Email"
                className="w-full px-4 py-2 bg-[#F1F4F9] text-black border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                required
              />
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className={`w-full bg-[#6F1AFF] text-white font-semibold py-2 rounded-md transition ${isLoading ? 'opacity-50 cursor-not-allowed' : 'hover:bg-[#6939e8]'}`}
            >
              {isLoading ? 'Adding...' : 'Add Member'}
            </button>
          </form>

          <p className="text-[#00217A] text-[20px] mt-3">
            <Link to="/add-member" className="text-[#00217A] text-[20px] font-bold hover:underline">
              Skip
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TeamManagement;